import { render } from "./ResultGroup.vue?vue&type=template&id=0df9001a&scoped=true"
import script from "./ResultGroup.vue?vue&type=script&lang=js"
export * from "./ResultGroup.vue?vue&type=script&lang=js"

import "./ResultGroup.vue?vue&type=style&index=0&id=0df9001a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df9001a"]])

export default __exports__